// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"313":"core-components-deferred","511":"core-components","870":"vendors-editor","985":"vendors-extra"}[chunkId] || chunkId) + "." + {"277":"4788bd68","313":"ed1479b7","511":"cf70efcf","870":"4487e441","985":"8476b9ee"}[chunkId] + ".chunk.js";
};